import React,{useEffect,useState} from 'react'
import {Link} from "react-router-dom";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
// import axios from "axios";
import axios from "../helper/axios";
import {useSelector,useDispatch} from "react-redux";
import {CopyToClipboard} from 'react-copy-to-clipboard';


export default function ProductList() {
  const [allProduct,setAllProduct] = useState([]);
  const [ copied, setCopied] = useState(false);
  const auth = useSelector(state=>state.auth);

  const apiData=async()=>{ 
    const res= await axios.post("/getstatus"); 
    if(res.status===200){
      setAllProduct(res?.data);
    }else{
      setAllProduct()
    }
  }

  useEffect(()=>{
    apiData();
  },[])
console.log(allProduct)



const copyBoard=()=>{
   setCopied(true) 

}
	return (
		<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  {auth?.user?.role==="Vendor"?<VendorSidebar/>:<Sidebarr/>}
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">

    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        All Images List
        <small>it all starts here</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>
    </section>
    {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box-header with-border"> 
          <div className="box-tools pull-right">
            <Link
              to="/status"
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="View"
            >
              <i className="fa fa-eye" />
              {" Add Status  "}
            </Link>
            {" "} 
          </div>
        </div>
      <div className="box"> 
        <div className="box-body">
        	<table className="table table-bordered table-striped dataTable" id="example2">
        	  <thead>
        	    <tr> 
              <th>Status Name</th>
        	  	<th>Status Preview</th>
              <th>Status Description</th>
              <th>Action</th>
        	  	</tr>
        	  </thead>
        	  <tbody>
            {allProduct?.map((dt)=>(
        	  	<tr> 
                <td>
                  <span className="text-uppercase fs-1">
                    {dt?.statusName}
                  </span>
                </td>
        	  		<td>
        	  			<span className="text-uppercase fs-1" style={{backgroundColor:`${dt?.statusColor}`,padding:"1px 5px", color:`${dt?.statusTextColor}`, borderRadius:"2px"}}>{dt?.statusName}</span>
        	  		</td>
                <td>
                  <span className="text-uppercase fs-1">{dt?.statusDesc}</span>
                </td>
                  
        	  		<td>
        	  			<Link to={"/addbanner"} className="btn btn-default">
        	  				<i className="fa fa-pencil"></i>
        	  			</Link>
        	  		 
        	  		</td>
        	  	</tr>
              ))}
        	  </tbody>
        	</table>
        </div>
        {/* /.box-body */}
        {/*<div className="box-footer">Footer</div>*/}
        {/* /.box-footer*/}
      </div>
      {/* /.box */}
    </section>
    {/* /.content */}
  </div>
  {/* /.content-wrapper */}
 


       <Footer/>
       <Tool/> 
   
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}